export const calculateEmployeePercentage = (categoryCount: number, totalCount: number) => {
  const percentInCategory = Math.round((categoryCount / totalCount) * 100);
  const percentNotInCategory = 100 - percentInCategory;

  return { percentInCategory, percentNotInCategory };
};
